const getApiBaseUrl = () => {
  const configuredApiUrl = (process.env.REACT_APP_API_URL || "").trim();
  const fallbackOrigin =
    typeof window !== "undefined" ? window.location.origin : "";

  return (configuredApiUrl || fallbackOrigin).replace(/\/+$/, "");
};

export default getApiBaseUrl;
